import { query } from '../utilities';

export const geoCitySearch = (q) => {
    return query('/geo/city/search/', {
        params: { query: q }
    });
};
